import React, {Component} from 'react';
import './styles.css';

interface Props {
    name?: string;
    onSetName: (name: string) => void;
}

export default class PlayerLogin extends Component<Props> {
    public render(): JSX.Element {
        return (
            <div className="PlayerLogin">
                <p>Enter your nickname</p>
                <input id="PlayerLogin-input" value={this.props.name} onChange={this.onChange} />
            </div>
        );
    }

    private onChange = (event: React.FormEvent<HTMLInputElement>) => {
        this.props.onSetName(event.currentTarget.value);
    };
}



// WEBPACK FOOTER //
// ./src/PlayerLogin/index.tsx